/**
 * Video Modal
 */

// Vendors
import $ from 'jquery';
import Player from '@vimeo/player';

// Play button event handler
$('[data-video-modal]').on('click', (event) => {
  if (!event) return;

  event.preventDefault();

  const self = $(event.currentTarget);
  const videoId = self.data('video-id');
  const videoSource = self.data('video-source');
  const videoTitle = self.data('video-title');
  const videoDescription = self.data('video-description');
  const userEmail = self.data('video-log-hs');
  const videoIframe = document.createElement('iframe');
  const videoSources = {
    youtube: `https://www.youtube.com/embed/${videoId}?modestbranding=1&autohide=1&showinfo=0&autoplay=1&rel=0`,
    vimeo: `https://player.vimeo.com/video/${videoId}?badge=0&byline=0&portrait=0&title=0&autoplay=1&autopause=0&playsinline=1`
  };
  let player;
  const timeupdateCallback = (playerData) => {
    if (videoSource === 'vimeo') {
      if (playerData.percent >= 0.25) {
        if (window._hsq) {
          _hsq.push(['identify', { email: userEmail }]);
          _hsq.push([
            'trackCustomBehavioralEvent',
            {
              name: 'pe3572053_watched_video',
              properties: {
                video_source: videoSource,
                video_id: videoId
              }
            }
          ]);
          _hsq.push([
            'trackEvent',
            { id: `Watched ${videoSource} video: ${videoId}` }
          ]);
        }

        // Kill listener
        player.off('timeupdate', timeupdateCallback);
      }
    } else {
      if (player.currentTime >= player.duration && hubspotFormId) {
      }
    }
  };

  if (!videoSources[videoSource]) return;

  videoIframe.className = 'video-modal__iframe';
  videoIframe.setAttribute('allowFullScreen', '');
  videoIframe.setAttribute('allow', 'autoplay');

  $('.video-modal__title').text(videoTitle);
  $('.video-modal__description').text(videoDescription);
  $('.video-modal__player').append(videoIframe);

  videoIframe.src = videoSources[videoSource];

  // We'll need the vimeo api to track video progress
  if (videoSource === 'vimeo') {
    player = new Player(videoIframe);
    player.play(); // (As a fallback, since videos should autoplay after load.)

    // Only log progress to Hubspot if user is logged in, otherwise don't bother.
    if (userEmail) {
      player.on('timeupdate', timeupdateCallback);
    }
  }

  if (videoTitle) $('.video-modal').addClass('video-modal--has-title');
  if (videoDescription)
    $('.video-modal').addClass('video-modal--has-description');

  $('html, body').addClass('video-modal-is-visible');
  $('.video-modal').addClass('video-modal--visible');
});

$('[data-video-modal-close]').on('click', (event) => {
  if (event) event.preventDefault();

  $('html, body').removeClass('video-modal-is-visible');
  $('.video-modal').removeClass('video-modal--visible');

  setTimeout(() => {
    $('.video-modal').removeClass('video-modal--has-title');
    $('.video-modal').removeClass('video-modal--has-description');
    $('.video-modal__title').text('');
    $('.video-modal__description').text('');
    $('.video-modal__iframe').remove();
  }, 300);
});
